// extracted by mini-css-extract-plugin
export default {"captureBackgroundClick":"TableCellControl-module__captureBackgroundClick--s6pbC"};